var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 12,
    fill: "#081127"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 56.6666C30.795 56.6666 23.3333 49.2049 23.3333 39.9999C23.3333 30.7949 30.795 23.3333 40 23.3333C49.205 23.3333 56.6666 30.7949 56.6666 39.9999C56.6666 49.2049 49.205 56.6666 40 56.6666ZM34.1666 43.3333V46.6666H38.3333V49.9999H41.6666V46.6666H43.3333C44.4384 46.6666 45.4982 46.2276 46.2796 45.4462C47.061 44.6648 47.5 43.605 47.5 42.4999C47.5 41.3949 47.061 40.335 46.2796 39.5536C45.4982 38.7722 44.4384 38.3333 43.3333 38.3333H36.6666C36.4456 38.3333 36.2337 38.2455 36.0774 38.0892C35.9211 37.9329 35.8333 37.7209 35.8333 37.4999C35.8333 37.2789 35.9211 37.0669 36.0774 36.9107C36.2337 36.7544 36.4456 36.6666 36.6666 36.6666H45.8333V33.3333H41.6666V29.9999H38.3333V33.3333H36.6666C35.5616 33.3333 34.5018 33.7722 33.7204 34.5536C32.939 35.335 32.5 36.3949 32.5 37.4999C32.5 38.605 32.939 39.6648 33.7204 40.4462C34.5018 41.2276 35.5616 41.6666 36.6666 41.6666H43.3333C43.5543 41.6666 43.7663 41.7544 43.9226 41.9107C44.0788 42.0669 44.1666 42.2789 44.1666 42.4999C44.1666 42.7209 44.0788 42.9329 43.9226 43.0892C43.7663 43.2455 43.5543 43.3333 43.3333 43.3333H34.1666Z",
    fill: "url(#paint0_linear_101_265)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_265",
    x1: 23.3333,
    y1: 27.4999,
    x2: 57.138,
    y2: 28.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF02C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRevenue);
export default __webpack_public_path__ + "static/media/totalRevenue.856daf78ee8a77923a1d7e284540b259.svg";
export { ForwardRef as ReactComponent };